<template>
  <basic-page>
    <a-col :span="24" slot="header">
      <a-row class="relation-list">
        <!-- a-col :span="8">
          <span style="color: #1890ff"
            >长尾&nbsp;<a-icon
              :component="CorrelateIcon"
              style="height:16px; width:16px;"
          /></span>
        </a-col -->
        <a-col :span="24" v-if="total > 0" style="text-align: left;">
          <span style="color: gray">共找到<span style="color: red">{{ total }}</span>条数据</span>
        </a-col>
        <a-col :span="24" v-else="" style="text-align: left;">
          <span style="color: gray">&nbsp;</span>
        </a-col>
      </a-row>
    </a-col>
    <a-row slot="content">
      <a-col>
        <search-panel mode="ver">
          <a-row :span="24" slot="search">
            <a-col>
              <a-col>
                <a-tree-select                  
                  :style="treeStyle"
                  placeholder="请输入或选择种子词"
                  size="large"
                  :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                  :treeData="treeData"
                  @change="handleTask"
                  @search="searchKey"
                  allowClear
                  multiple
                  treeDefaultExpandAll
                  v-model="task_value"
                >
                </a-tree-select>
              </a-col>
              <a-col>
                <a-checkbox
                  v-if="isqa == true"
                  style="position: absolute; top: -36px; right: 0px;"
                  @change="handleCheckbox"
                  :style="autoMargin"
                  checked>
                  仅限问句
                </a-checkbox>
                <a-checkbox
                  v-else=""
                  style="position: absolute; top: -36px; right: 0px;"
                  @change="handleCheckbox"
                  :style="autoMargin">
                  仅限问句
                </a-checkbox >
                <a>
                  <a-icon type="search" style="font-size: 20px; position: absolute; top: 10px; right: 2px; " @click="onSearch"></a-icon>
                </a>
              </a-col>
              <a-col style=" margin-top: 4px; text-align: left;" :span=24>
                <a-select
                  :defaultValue="depth"
                  @change="handleDepth"
                  size="default"
                  :style="depthStyle"
                >
                  <a-select-option v-for="depth in depthLevel" :key="depth">{{
                    depth
                  }}</a-select-option>
                </a-select>
              </a-col>
            </a-col>
          </a-row>
        </search-panel>
      </a-col>
      <a-col 
            v-if="user_tree == false " 
            :span="24" 
            style="padding: 12px 0px; text-align: left; ">
            <span style="margin-right: 8px;">请点击<router-link to="/uc/ltls" style="color: blue;">此处</router-link>设置长尾种子词</span>
      </a-col>
      <a-col 
            v-if="task_status == 0 " 
            :span="24" 
            style="padding: 12px 0px; text-align: left;"
            >
            <span>没有发现任何文章，请尝试其他选项</span>
      </a-col>
      <a-col v-if="total > 0" :span="24" class="setting-list">
        <a-row v-for="(item, index) in output" :key="index">
          <a-col class="list-border">
            <span
              @click="handleArticle(index)"
              :style="autoMargin"
              class="item-list"
              ><a>{{ item.word }}</a></span
            >
            <a-col v-if="item.total_article == 0 && item.show == true" class="article-list">
              <span>没有发现任何文章，请尝试其他选项</span>
            </a-col>
            <a-row v-if="item.show == true">
              <a-col
                v-for="(atcl, order) in item.article"
                :key="order"
                v-if="atcl.title != '' && order < 10"
                class="article-list"
              >
                <a
                  :href="atcl.url"
                  style="color: blue;font-weight: 600;"
                  target="_blank"
                  >{{ atcl.title }}</a
                ><br />
                <span style="color: gray">{{ atcl.abstract }}</span>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-col :span="24" slot="loadmore" v-if="total > 0 && loadmore== true">
      <a-row>
        <a-button @click="loadMore">加载更多</a-button>
      </a-row>
    </a-col>
  </basic-page>
</template>

<script>
import { SearchPanel } from "@/com/Basic";
import BasicPage from "@/layout/BasicPage.vue";

const depthLevel = ["全部", "0层", "1层", "2层", "3层", "4层"];

export default {
  name: "longtailsearch",
  data() {
    return {
      depthLevel,
      task_value: undefined,
      treeData: [],
      user_tree: true,
      tab: "ltl",
      abcList: [],
      seedwords: "",
      task_id: "",
      term_id: "",
      task_name: "",
      user_value: "",
      depth: "全部",
      isqa: false,
      loadmore: true,
      total: "",
      task_status: "undefined",
      output: [],
      page: 0,
      autoMargin: { marginLeft: "8px" },
      treeStyle: { width: "100%", height: "40px" },
      depthStyle: { width: "100%" }
    };
  },
  watch: {
    task_value(newvalue, oldvalue) {
      //console.log(oldvalue)
    }
  },
  components: {
    BasicPage,
    SearchPanel
  },
  methods: {
    searchKey(value) {
      this.task_id= "";
      this.user_value= value;
    },
    onSearch() {
      if(this.user_tree== false){
        return
      }
      else if(this.user_value== ""){
        return
      } else{
        var depth;
        if (this.depth == "全部") {
          depth = "";
        } else {
          depth = this.depth;
        }
        this.page = 0;
        if(this.task_id== undefined || this.task_id== ""){
          this.task_name=this.user_value;
          this.task_id=this.treeData[0].key
        }
        let postdata = {
          task: "LONGTAIL_TASK_QUERY",
          task_id: this.task_id,
          keyword: this.task_name,
          depth: depth,
          isqa: this.isqa,
          from: this.page * 25,
          to: (this.page + 1) * 25
        };
        let that = this;
        let loading = that.$message.loading("搜索中...", 0);
        that
          .post("/longtail", postdata)
          .then(function(data) {
          setTimeout(loading, 0);
            if (data.ret == 200) {
              if (data.total == undefined) {
                that.task_status= 0;
              }
              else if (data.total <= 25) {
                that.loadmore= false
                that.task_status= 1;
              } else{
                that.loadmore= true
                that.task_status= 1;
              } 
              that.page += 1;
              that.total = data.total;
              that.output = data.data;
              postdata["total"] = data.total;
              postdata["loadmore"] = that.loadmore;
              postdata["task_status"] = that.task_status;
              that.$store.commit("updatepostdata", {
                post: postdata,
                tab: "ltl"
              });
              that.$store.commit("updateresult", {
                result: data.data,
                tab: "ltl"
              });
            } 
          })
          .catch(function(e) {
            console.log(e);
            setTimeout(loading, 0);
            that.$message.error("failed");
          });
      }
    },
    handleTask(value, label, extra) {
      if(value.length < 1){
        this.user_value= "";
      }
      else{
        let valuePattern = [];
        for (let i = 0; i < value.length; i++) {
          valuePattern = value[i].split("*#D3D#*");
        }
        this.task_name = valuePattern[0];
        this.user_value= valuePattern[0];
        this.task_id = valuePattern[1];
      }
    },
    handleDepth(value) {
      this.depth = value;
    },
    handleCheckbox(e) {
      this.isqa = e.target.checked;
    },
    handleArticle(index) {
      if (this.output[index].show == true) {
        let item = this.output[index];
        item.show = false;
        this.$set(this.output, index, item);
        return;
      } else if (this.output[index].article) {
        let item = this.output[index];
        item.show = true;
        this.$set(this.output, index, item);
        return;
      } else {
        let postdata = {
          task: "LONGTAIL_ARTICLE_QUERY",
          task_id: this.task_id,
          term_id: this.output[index].term_id
        };
        let that = this;
        let loading = that.$message.loading("搜索中...", 0);
        that
          .post("/longtail", postdata)
          .then(function(data) {
            setTimeout(loading, 0);
            if (data.ret == 200) {
              let item = that.output[index];
              item["show"] = true;
              item["article"] = data.data;
              item["total_article"] = data.total;
              that.$set(that.output, index, item);
            } else {
              that.$message.info(data.msg);
            }
          })
          .catch(function(e) {
            console.log(e);
            setTimeout(loading, 0);
            that.$message.error("failed");
          });
      }
    },
    loadMore() {
      var depth;
      if (this.depth == "全部") {
        depth = "";
      } else {
        depth = this.depth;
      }
      let postdata = {
        task: "LONGTAIL_TASK_QUERY",
        task_id: this.task_id,
        keyword: this.task_name,
        depth: depth,
        isqa: this.isqa,
        from: this.page * 25,
        to: (this.page + 1) * 25
      };
      let that = this;
      let loading = that.$message.loading("搜索中...", 0);
      that
        .post("/longtail", postdata)
        .then(function(data) {
        setTimeout(loading, 0);
          if (data.ret == 200) {
            if (data.data.length < 25) {
              that.loadmore= false
              that.task_status= 1;
            } else{
              that.loadmore= true
              that.task_status= 1;
            }
            that.page += 1;
            that.total = data.total;
            postdata["total"] = data.total;
            postdata["loadmore"] = that.loadmore;
            postdata["task_status"] = that.task_status;
            for (let i = 0; i < data.data.length; i++) {
                that.output.push(data.data[i]);
            }
            that.$store.commit("updatepostdata", {
              post: postdata,
              tab: "ltl"
            });
            that.$store.commit("updateresult", {
              result: that.output,
              tab: "ltl"
            });
          }
        })
        .catch(function(e) {
          console.log(e);
          setTimeout(loading, 0);
          that.$message.error("failed");
        });
    }
  },
  created() {
    this.$store.commit("changetab", this.tab);
    let position = this.$store.getters.getPosition();
    let postdata = this.$store.getters.getPostdata();
    let result = this.$store.getters.getResult();
    this.output = result;
    this.total = postdata.total;
    this.task_name = postdata.keyword;
    this.task_value = postdata.keyword;
    this.task_id = postdata.task_id;
    this.loadmore = postdata.loadmore;
    this.task_status = postdata.task_status;
    if (postdata.depth ==undefined || postdata.depth == "" ){
        this.depth="全部";
      }
    else{
        this.depth=postdata.depth;
      }
    this.isqa = postdata.isqa;
    let page = postdata.to;
    this.page = page / 25;
    postdata = {
      task: "LONGTAIL_SEEDWORD_LIST",
      "api-path": "longtail",
      from: 0,
      to: 100
    };
    let that = this;
    that
      .post(postdata["api-path"], postdata)
      .then(function(data) {
        if (data.ret == 200) {
          that.abcList = data.data;
          if(that.abcList.length< 1){
            that.user_tree= false
          }
          for (let i = 0; i < that.abcList.length; i++) {
            that.treeData.push({
              title: that.abcList[i].task_name,
              value:
                that.abcList[i].task_name + "*#D3D#*" + that.abcList[i].task_id,
              key: that.abcList[i].task_id,
              children: []
            });
            let swString = that.abcList[i].seedwords;
            let swArray = swString.split(" ");
            for (let j = 0; j < swArray.length; j++) {
              that.treeData[that.treeData.length - 1].children.push({
                title: swArray[j],
                value:
                  swArray[j] +
                  "*#D3D#*" +
                  that.abcList[i].task_id +
                  "*#D3D#*" +
                  j,
                key: that.abcList[i].task_id + j
              });
            }
          }
        }
      })
      .catch(function(e) {});
  }
};
</script>

<style scoped>
    .relation-list {
      text-align: left;
      padding: 8px;
      border-bottom: 1px solid #d1d5da;
      background-color: #f5f6f5 /*#f1f8ff*/;
    }

    /deep/ .ant-select-selection__clear {
      display: none;
    }

    div /deep/ .ant-select-lg {
        font-size: 14px;
    }

    div /deep/ .ant-select-not-found {
      display: none;
    }
    .setting-list {
      margin-top: 8px;
      border: 1px solid #d1d5da;
    }
    .list-border {
      color: gray;
      padding: 12px 0px;
      text-align: left;
      border-bottom: 1px solid #d1d5da;
    }
    .item-list {
      font-size: 16px;
      font-weight: 600;
    }
    .article-list {
      padding: 8px 8px;
      text-align: left;
    }
</style>
